const setStateAsync = function setStateAsync (state) {
  return new Promise((resolve) => {
    this.setState(state, resolve)
  })
}

export default setStateAsync



// WEBPACK FOOTER //
// ./src/helpers/setStateAsync.js